import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload } from "lucide-react";

export function ImageUploader({ value, onChange, testid, shape = "square", label = "Upload image" }) {
  const [busy, setBusy] = useState(false);
  const src = value ? (value.startsWith("http") ? value : `${process.env.REACT_APP_BACKEND_URL}${value}`) : null;
  const onFile = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Image uploaded");
    } catch { toast.error("Upload failed"); }
    finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div className="flex items-center gap-4">
      <div className={`${shape === "round" ? "rounded-full" : "rounded-xl"} h-16 w-16 border border-stone-200 bg-stone-50 overflow-hidden flex items-center justify-center shrink-0`}>
        {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : <Upload className="h-5 w-5 text-stone-400" />}
      </div>
      <label className="cursor-pointer">
        <input type="file" accept="image/*" data-testid={testid} className="hidden" onChange={onFile} />
        <span className="inline-flex items-center px-4 py-2 rounded-full border border-stone-300 text-sm hover:bg-stone-50">{busy ? "Uploading…" : label}</span>
      </label>
    </div>
  );
}
